import _ from 'lodash';

export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please log out and log in again.';

// A 401 is the API gateway rejecting an expired login token before the request reaches the service.
export const requestErrorMessage = (err, fallback) => (
  _.get(err, 'response.status') === 401
    ? SESSION_EXPIRED_MESSAGE
    : (_.get(err, 'response.data.error') || _.get(err, 'message') || fallback)
);



/** WEBPACK FOOTER **
 ** ./src/utils/request-error-message.js
 **/